import { useTranslation } from "react-i18next";
import { Button, ButtonGroup, Form, Icon, Input, TextArea } from "semantic-ui-react";

import { PinTypeIcon, PriceInput } from "components";
import { useShowPriceInVat } from "hooks";
import "modules/AppointmentDetails/components/Interventions/components/GeneralInfo/GeneralInfo.scss";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";
import "modules/HoldingAppointmentDetails/components/Interventions/components/GeneralInfo/GeneralInfo.scss";
import { getInterventionPriceWithVAT } from "utils/common";
import { formatPrice } from "utils/formatPrice";

import type { Appointment, Intervention, PIN_TYPES } from "models";

type GeneralInfoProps = {
  intervention: Intervention;
  appointment: Appointment | null;
  typeID: PIN_TYPES | null;
};

export const GeneralInfo = ({ intervention, typeID }: GeneralInfoProps) => {
  const { t } = useTranslation();

  const selectedLocation = useAppointmentLocation();

  const showPriceInVat = useShowPriceInVat();

  return (
    <div className="GeneralInfo">
      <Form>
        <Form.Group className="input-row-equal-spacing">
          <Form.Field width={16} required>
            <label>{t("v8_title", "Title")}</label>
            <Input defaultValue={intervention.title} placeholder="Title" fluid name="title" disabled />
          </Form.Field>

          {selectedLocation?.dms_price_enabled && (
            <Form.Field width={2} className="mt-28">
              <PriceInput
                name="price"
                labelPosition="right"
                value={formatPrice(showPriceInVat ? getInterventionPriceWithVAT(intervention, selectedLocation) : intervention.price)}
                label={{ basic: true, content: "€" }}
                disabled
              />
            </Form.Field>
          )}

          <Form.Field className="mt-28 label-dropdown-container">
            <ButtonGroup className="withdropdown">
              <Button className={`withdropdownButton readonly ${typeID === null ? "grey" : "black"}`}>
                <PinTypeIcon pinTypeId={typeID || 0} />
              </Button>
            </ButtonGroup>
          </Form.Field>

          <Form.Field width={1} className="mt-28 user-approved-icon">
            <Button className="wdLightGrey centerIcon greyBorder readonly" type="button">
              <Icon className={`${intervention.customer_ok ? "check circle green" : "remove circle red"}`} />
            </Button>
          </Form.Field>
        </Form.Group>

        <Form.Field width={16} className="mt-14">
          <label>{t("v8_description", "Description")}</label>
          <TextArea disabled defaultValue={intervention.description} placeholder="Write description" name="description" />
        </Form.Field>

        {intervention.internal_note && (
          <Form.Field width={16} className="mt-14">
            <label>{t("v8_dms_internal_note", "DMS Internal note")}</label>
            <div>{intervention.internal_note}</div>
          </Form.Field>
        )}
      </Form>
    </div>
  );
};
